module.exports = "/images/footer.png?ef013f813cb49d1506afad3f61b61aab";